import { StyleSheet, Platform, Dimensions } from 'react-native';

import { PlatformUtils } from '@vfgroup-oneplatform/foundation/Utils';

const isIPhoneWithNotch = PlatformUtils.isIPhoneDeviceWithNotch();

export default StyleSheet.create({
  overlayLottie: {
    height: 156,
    width: 156,
  },
  containerStyle: {
    paddingHorizontal: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? '10%' : 17,
    paddingTop: Platform.OS === 'ios' ? (isIPhoneWithNotch ? 53 : 43) : 53,
    flex: 1,
  },
  changePasswordTitle: theme => ({
    fontSize: Platform.OS === 'ios' ? 25 : 24,
    fontWeight: 'bold',
    color: theme.colors.textColor,
  }),
  changePasswordSubtitle: theme => ({
    fontSize: Platform.OS === 'ios' ? 16.6 : 16,
    marginTop: 16,
    color: theme.colors.textColorTwo,
  }),
  mainCard: theme => ({
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    elevation: 2,
    shadowColor: 'rgba(0, 0, 0, 0.16)',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 4,
    shadowOpacity: 1,
    marginTop: 17,
    marginBottom: 150,
    paddingHorizontal: 17,
    paddingBottom: 17,
    paddingTop: 34,
  }),
  inputContainerStyle: {
    width: '100%',
    marginHorizontal: 0,
    marginTop: 0,
    marginBottom: 0,
  },
  newPasswordTitle: theme => ({
    marginTop: 32,
    marginBottom: 25,
    color: theme.colors.textColorTwo,
    fontSize: Platform.OS === 'ios' ? 16.6 : 16,
  }),
  confirmNewPassword: {
    marginTop: 23,
  },
  sectionSeparator: theme => ({
    borderTopWidth: 1,
    borderColor: theme.colors.horizontalLineColor,
    marginTop: 40,
    marginBottom: 17,
  }),
  confirmButton: theme => ({
    backgroundColor: theme.colors.buttons.disabled,
  }),
  confirmButtonText: theme => ({
    color: theme.colors.textButtons.disabled,
  }),
  keyboardAvoidingViewStyle: {
    paddingBottom: Platform.OS === 'ios' ? 0 : 5,
    flex: 1,
  },
});
